// @ts-check


/**
 * @typedef {import("../../../mat/js/types/PL_ReduxTypes").PL_ReduxStore} PL_ReduxStore
 * @typedef {import("../../../mat/js/types/PL_ReduxTypes").ReduxDispatch} ReduxDispatch
 * @typedef {import("../../../mat/js/types/PL_ReduxTypes").ReduxGetState} ReduxGetState
 * 
 */


export default class StoreRegistry {
  
  
  /** @type {PL_ReduxStore | null} */
  static #defaultStore = null;
  
  constructor() {
    
  }
  

  /**
   * @param {PL_ReduxStore} store
   */
  static registerDefaultStore(store) {
    StoreRegistry.#defaultStore = store;
  }

  
  static getDefaultStore() {
    
    if (!StoreRegistry.#defaultStore) {
      throw new Error(`Default store is not registered.`);
    }
    
    return StoreRegistry.#defaultStore;
  }

  
  /**
   * @param {string} type
   * @param {any} payload
   */
  static runAction(type, payload) {
    const store = StoreRegistry.getDefaultStore();
    
    const action = { type, payload };
    store.dispatch(action);
  }
  
  
}


// @ts-ignore
if (__DEV__) {
  // @ts-ignore
  window.StoreRegistry = StoreRegistry;
}


